import React, {useEffect, useState} from "react";
import axios from 'axios';
import TrackVisibility from "react-on-screen";
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import Progress from "../components/Progress";
import {useTranslation} from "react-i18next";

function Resumes() {
    const [skills, setSkills] = useState([]);
    const [frameworks, setFrameworks] = useState([]);
    const [altro, setAltro] = useState([]);
    const [os, setOs] = useState([]);
    const {t} = useTranslation('common');

    useEffect(() => {
        axios.get('/api/skills')
            .then(response => {
                setSkills(response.data);
            });
        axios.get('/api/frameworks')
            .then(response => {
                setFrameworks(response.data);
            });
        axios.get('/api/os')
            .then(response => {
                setOs(response.data);
            });
        axios.get('/api/altro')
            .then(response => {
                setAltro(response.data);
            });
    }, []);

    return (
        <Layout>
            <div className="mi-skills-area mi-section mi-padding-top">
                <div className="container">
                    <Sectiontitle title="skills.subtitle"/>

                    <div className="mi-smalltitle"><h4 className="sub-title-custom">{t("skills.subtitle1")}</h4>
                    </div>

                    <div className="mi-skills">
                        <div className="row mt-30-reverse">
                            {skills.map(skill => (
                                <TrackVisibility once className="col-lg-6 mt-30" key={skill.title}>
                                    <Progress title={skill.title} percentage={skill.value}/>
                                </TrackVisibility>
                            ))}
                        </div>
                    </div>

                    <div className="mi-smalltitle"><h4 className="sub-title-custom">{t("skills.subtitle2")}</h4></div>

                    <div className="mi-skills">
                        <div className="row mt-30-reverse">
                            {frameworks.map(framew => (
                                <TrackVisibility once className="col-lg-6 mt-30" key={framew.title}>
                                    <Progress title={framew.title} percentage={framew.value}/>
                                </TrackVisibility>
                            ))}
                        </div>
                    </div>

                    <div className="mi-smalltitle"><h4 className="sub-title-custom">{t("skills.subtitle3")}</h4></div>

                    <div className="mi-skills">
                        <div className="row mt-30-reverse">
                            {os.map(osystem => (
                                <TrackVisibility once className="col-lg-6 mt-30" key={osystem.title}>
                                    <Progress title={osystem.title} percentage={osystem.value}/>
                                </TrackVisibility>
                            ))}
                        </div>
                    </div>

                    <div className="mi-smalltitle"><h4 className="sub-title-custom">{t("skills.subtitle4")}</h4></div>

                    <div className="mi-skills">
                        <div className="row mt-30-reverse">
                            {altro.map(item => (
                                <TrackVisibility once className="col-lg-6 mt-30" key={item.title}>
                                    <Progress title={item.title} percentage={item.value}/>
                                </TrackVisibility>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
            <div className="mt-30"></div>
        </Layout>
    );
}

export default Resumes;
